/* eslint-disable react-hooks/exhaustive-deps */
import { Intent, Overlay2, Position, Tooltip } from "@blueprintjs/core"
import { Fragment, useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { showToast } from "src/libs/useful"
import Shortcode from "src/libs/useful/shortcode"
import { __, getContrastColor, getCssDemention, } from "src/libs/utilities"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { DotNavigation, DotsNavigationContent, ILanding, ILandingSection, LANDING_TYPE_CONTENT } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { useLandingScroll } from "src/modules/pe-landing-module/hooks/useLandingScroll"
import { getLandingContainer } from "../../utils/getLandingContainer"
import { IPrimitiveProps } from "../section/Primitive"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import DotNavigationEditor from "../landing-edit/editors/dot-navigation/DotNavigationEditor"

/* Protopia Ecosystem component */  
const DotsNavigationPrimitive = (props: IPrimitiveProps): JSX.Element => {
    const {section} = useLandingScroll("section")
    const  isEdit                           = useLandingStore((state: ILandingStore) => state.isEdit)
    const currentLanding: ILanding	        = useLandingStore((state: ILandingStore) => state.currentLanding) 
    const primitive: DotsNavigationContent  = ( props.primitive || {} ) as DotsNavigationContent 
    const active = useSyncState<number>(0)
    useEffect(() => {
        addCSSClass(
            `landing-dots-navigation-${primitive?.id}`,
            ` .landing-dots-navigation-${primitive?.id} {
               position: fixed;
               top:50%;
               display: flex;
               flex-direction: column;
               align-items: ${ primitive.align || "flex-end" };
               gap: ${ getCssDemention( primitive.gap || 10 ) };
               right: ${ getCssDemention( primitive.distance, "20px" ) };
               z-index: 100;
            }
            .dot-navigation-${primitive?.id} {
                width: ${ getCssDemention( primitive.width || 20 ) };
                height: ${ getCssDemention( primitive.height || 20 ) };
                background: ${primitive.color || 'var(--force-contrast-opacity-color)'};
                border-color: ${primitive.borderColor || "var(--force-contast-color)"};
                border-width: ${getCssDemention( primitive.borderWidth || 1 )};
                border-style: solid;
                border-radius: ${getCssDemention( primitive.borderRound || 0)};
                user-select: none;
                &.active {                
                    background: ${primitive.activeColor || 'var(--actual-success-color)'};
                    width: ${ getCssDemention( primitive.activeWidth || primitive.width || 20  )  };
                    height: ${ getCssDemention( primitive.activeHeight || primitive.height || 20 ) };
                    border-color: ${primitive.activeBorderColor};
                    border-width: ${primitive.activeBorderWidth}; 
                }
            }
            .popover-dots-navigation-${primitive?.id} .bp5-tooltip .bp5-popover-content{
                ${
                    primitive.tooltipColor 
                        ? 
                        `background-color: ${primitive.tooltipColor}; color: ${ getContrastColor( primitive.tooltipColor )};` 
                        : 
                        ``
                }
            }
            .popover-dots-navigation-${primitive?.id} .bp5-tooltip .bp5-popover-arrow-fill {
                ${primitive.tooltipColor ? `fill: ${primitive.tooltipColor};` : ``}
            }
            `
        )
        return () => {
            removeCSSClass(`landing-dots-navigation-${primitive?.id}`)
        }
    }, [])

    useEffect(() => {
        primitive.items?.forEach((item, i) => {
            if(item.anchor === section.id){
                active.set(i)
            }
        })
    }, [ section ])
    
    if(isEdit) {
        return <Tooltip
            intent={ Intent.PRIMARY }
            position={ Position.TOP_LEFT }
            compact
            content={ <div className="small letter-spacing-2">{ __( components()[ primitive.type ].title ) }</div> }
        >
            <div className="icon-square bg-light m-1  pointer user-select-none" data-select-type="ignore">
                <img 
                    src={components()[LANDING_TYPE_CONTENT.DOTS_NAVIGATION].icon}
                    height={ 14 }
                    alt=""
                />
            </div>
        </Tooltip>
    }
    if(!primitive.items?.length) return <></>

    const onClick = (i: number) => {
        //active.set(i)
        const anchor = primitive.items[i].anchor?.toString()
        const element = document.getElementById( anchor )
        if(!!element) { 
            const lScroll = getLandingContainer().scrollTop   
            getLandingContainer().scrollTo({
                behavior: 'smooth',
                top: lScroll + element.getBoundingClientRect().top,
            })
        }
        else {
            showToast({
                message: "Error.Not exists this section",
                intent: Intent.DANGER
            })
        }
    }

    return <Overlay2 isOpen={ true } hasBackdrop={ false } >
        <>        
            <div className={`pe-primitive-container landing-portal landing-dots-navigation landing-dots-navigation-${primitive?.id}`}>
                {
                    //currentLanding.sections
                    primitive.items
                        .map((dot, i) => { 
                            //let dot: DotNavigation | undefined = primitive.items.find( item => section.id === item.anchor?.toString().replace( "#", "" ) )
                            const section = currentLanding.sections.find(s => s.id === dot.anchor?.toString().replace( "#", "" ))
                            if(!section || section.isHidden || dot?.isHidden ) {
                                return <Fragment key={i} />
                            }
                            if(!dot) {
                                dot = {
                                    anchor: section.id,
                                    title: section.title.text || section.data[0]?.defaultTitle || "Section " + section.id
                                }
                            }
                            return primitive.tooltip
                                ?
                                <Tooltip
                                    key={i} 
                                    position={ Position.LEFT }
                                    content={
                                        <Shortcode className="landing-tooltip px-2 p-0 small" content={ dot.title } />
                                    }
                                    portalClassName={ `popover-dots-navigation-${ primitive?.id }` }
                                    // isOpen
                                >
                                    <SingleDot 
                                        item={dot} 
                                        primitive={ primitive } 
                                        isActive={i === active.get()} 
                                        onClick={() => onClick(i)}  
                                    />
                                </Tooltip>
                                :
                                <SingleDot 
                                    item={dot} 
                                    primitive={ primitive } 
                                    key={i} 
                                    isActive={i === active.get()} 
                                    onClick={() => onClick(i)} 
                                />
                        })
                }
            </div>
            <DotNavigationEditor item={primitive} />
        </>
    </Overlay2>
}
export default DotsNavigationPrimitive


/* Protopia Ecosystem component */
export interface ISingleDotProps {
    item: DotNavigation
    primitive: DotsNavigationContent
    isActive: boolean 
    onClick: () => void
}
export const SingleDot = (props: ISingleDotProps): JSX.Element => {
    return <div className={`pe-dot-navigation dot-navigation-${props.primitive?.id} ${props.isActive ? "active" : ""} `} onClick={props.onClick} id={ props.item.anchor?.toString() }>
       
    </div>
} 


const getDefaultTitle = (section: ILandingSection) => {
        if( !section.data.length) {
            return undefined
        }
        return section.data[0].defaultTitle
    }
export const getAllActiveSections = (): ILandingSection[] => {
    return useLandingStore.getState().currentLanding.sections
        .filter( (sec: ILandingSection) => !sec.isHidden )
            .map((sec: ILandingSection) => (
                {
                    "anchor": sec.id,
                    "title": sec.title?.text || getDefaultTitle(sec) || __("Section") + " " + sec.id
                }
            ))
}